import { render, staticRenderFns } from "./OnboardingImportChooseServiceModal.vue?vue&type=template&id=1d361a8e&scoped=true"
import script from "./OnboardingImportChooseServiceModal.vue?vue&type=script&lang=js"
export * from "./OnboardingImportChooseServiceModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImportChooseServiceModal.vue?vue&type=style&index=0&id=1d361a8e&prod&lang=scss&scoped=true"
import style1 from "./OnboardingImportChooseServiceModal.vue?vue&type=style&index=1&id=1d361a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d361a8e",
  null
  
)

export default component.exports